enum FontFamilyEnum {
  TEXT_FONT_FAMILY = '--text-font-family',
  HEADER_FONT_FAMILY = '--header-font-family',
  LABEL = '--label-font-family',
}

export default FontFamilyEnum;
